import React from "react"
import Tabs from "react-bootstrap/lib/Tabs"
import Tab from "react-bootstrap/lib/Tab"

import { logCashAlertOverThreshold } from "../../../../apis/Analytics/gtmActions"

import AlertModal from "../../../../ui-components/AlertModal"
import StripeCheckout from "./stripe/StripeCheckout"
import CashForm from "./CashForm"
import { ORDER_MAX_CASH_THRESHOLD } from "../../../../utils/config"
import SatispayForm from "./Satispay/SatispayForm"
import { CHANGE_PAYMENT_METHOD } from "../../../../stores/CartStateStore"
import { useState } from "react"

const PAYMENTS_TABS = {
  CASH: 1,
  CREDIT_CARD: 2,
  SATISPAY: 3,
}

export default function PaymentTypeSelector(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    userAuthToken,
    showAlertMessage,
    showStripeMethod,
    isTakeAway,
    venueAcceptsCash,
    venueAcceptsStripe,
    amount,
    deliveryPrice,
    cartState,
    dispatchCartState,
    errors,
    stripe_key
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [tab, setTab] = useState(getDefaultTabIndex())
  const [error, setError] = useState(null)
  const [cashAmount, setCashAmount] = useState("")

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function isCashDisabledByAmount() {
    return amount / 100.0 > ORDER_MAX_CASH_THRESHOLD && venueAcceptsStripe
  }

  function getDefaultTabIndex() {
    if (!venueAcceptsCash) {
      return PAYMENTS_TABS.CREDIT_CARD
    }

    if (isCashDisabledByAmount()) {
      return PAYMENTS_TABS.CREDIT_CARD
    }

    return PAYMENTS_TABS.CASH
  }

  function handleTabSelect(value) {
    switch (value) {
      case PAYMENTS_TABS.CASH:
        if (!venueAcceptsCash) {
          setError(I18n.t("cart_summary.venue_no_cash"))
          return
        }

        if (isCashDisabledByAmount()) {
          setError(
            I18n.t("cart_summary.cash_value_too_high_alert", {
              value: ORDER_MAX_CASH_THRESHOLD,
            })
          )
          logCashAlertOverThreshold()
          return
        }

        // also dispatched into CashForm
        // TODO: refactor
        dispatchCartState({
          type: CHANGE_PAYMENT_METHOD,
          payload: { type: "cash", options: { cash_amount: cashAmount } },
        })
        break
      case PAYMENTS_TABS.CREDIT_CARD:
        // actually dispatched into StripeCheckout
        // TODO: refactor StripeCheckout state management bad practice and dispatch here
        // dispatchCartState({type: CHANGE_PAYMENT_METHOD, payload: {type: 'satispay'}})
        break
      case PAYMENTS_TABS.SATISPAY:
        dispatchCartState({
          type: CHANGE_PAYMENT_METHOD,
          payload: { type: "satispay" },
        })
        break
    }

    setTab(value)
  }

  function renderCashForm() {
    return (
      <CashForm
        showAlertMessage={showAlertMessage}
        enabled={venueAcceptsCash}
        requiresCashValue={!isTakeAway}
        errors={errors}
        cartState={cartState}
        dispatchCartState={dispatchCartState}
        setCashAmount={setCashAmount}
      />
    )
  }

  function renderStripeForm() {
    return (
      <StripeCheckout
        userAuthToken={userAuthToken}
        stripe_key={stripe_key}
        shown={tab === 2}
        showAlertMessage={showAlertMessage}
        deliveryPrice={deliveryPrice}
        venueAcceptsStripe={venueAcceptsStripe}
        cartState={cartState}
        dispatchCartState={dispatchCartState}
      />
    )
  }

  function renderSatispayForm() {
    return <SatispayForm />
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  // GUARD
  if (!showStripeMethod) {
    return renderCashForm()
  }

  return (
    <div>
      <AlertModal
        onClose={() => setError(null)}
        show={!!error}
        title={I18n.t("cart_summary.warning")}
        text={error}
      />

      <Tabs
        className="payment-type-selector"
        activeKey={tab}
        onSelect={handleTabSelect}
        id="controlled-tab-example"
      >
        <Tab
          eventKey={1}
          title={
            <div>
              <i className="fa fa-money" aria-hidden="true" />{" "}
              {I18n.t("cart_summary.pay_with_cash")}
            </div>
          }
        >
          {" "}
          {renderCashForm()}
        </Tab>
        <Tab
          eventKey={2}
          title={
            <div>
              <i className="fa fa-credit-card" aria-hidden="true" />{" "}
              {I18n.t("cart_summary.pay_with_card")}
            </div>
          }
        >
          {" "}
          {renderStripeForm()}
        </Tab>
        <Tab
          eventKey={3}
          title={
            <div>
              <i className="far fa-mobile" aria-hidden="true" />{" "}
              {I18n.t("cart_summary.pay_with_satispay")}
            </div>
          }
        >
          {" "}
          {renderSatispayForm()}
        </Tab>
      </Tabs>
    </div>
  )
}
